import { Link } from "react-router-dom";
import axios from "axios";
import React, { useState } from "react";
import { BeatLoader } from "react-spinners";

export default function Contact1() {
        const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const [emailsending,setEmailSending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEmailSending(true);

        try {
            const { name, email, message } = formData;
            const response = await axios.post("http://localhost:8000/send-email", {
                name,
                email,
                message,
            });

            // alert("Message sent successfully!");
            setEmailSending(false)
            // Optionally reset form
            setFormData({ name: "", email: "", subject: "", message: "" });
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Failed to send message.");
        }
    };


    return (
        <>
            <section id="contact" className="contact-1-section pt-lg-0">
                <div className="auto-container">
                    <div className="row align-items-center">                
                        <div className="col-lg-6 order-lg-2">
                                      <div className="section_heading mb_60">
                            <span className="section_heading_title_small">Appointment</span>
                            <h2 className="section_heading_title_big">Want to Hear More About <br /> Newran SS Hospice?</h2>
                        </div>
                        <div className="contact-form">
                            <form onSubmit={handleSubmit} id="contact-form">
                                <div style={{fontWeight : 'bold', fontSize : '20px', marginBottom : '20px'}}>
                                    Call Us : 0422 411 652 Or Submit and Inquiry
                                    
                                    </div>
                                <div className="row clearfix">
                                    <div className="form-group col-md-6">
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Your Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group col-md-6">
                                        <input
                                            type="text"
                                            name="email"
                                            placeholder="Your Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group col-md-12">
                                        <input
                                            type="text"
                                            name="subject"
                                            placeholder="Subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group col-md-12">
                                        <textarea
                                            name="message"
                                            placeholder="Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>

                                    <div className="form-group col-md-12">
                                        <input id="form_botcheck" name="form_botcheck" className="form-control" type="hidden" value="4" />
                                        
                                        {emailsending ? (<BeatLoader color="#36d7b7"/>) : (
                                                <button className="btn-1 btn-small" type="submit">
                                            Submit now <i className="flaticon-right-arrow-1">
                                         </i><span></span>
                                        </button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                        <div className="col-lg-6 d-flex" style={{ height: '100vh' }}>
                            <div className="contact-map-banner w-100" style={{ flex: 1 }}>
                                <div className="gmap_canvas" style={{ width: '100%', height: '100%' }}>
                                  <iframe
                                        className="gmap_iframe"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6763.218365437241!2d115.99099034822375!3d-32.0527683239026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32bfd54a4ac56b%3A0x2cbd36cad7b407ea!2s7%20Birch%20St%2C%20Maddington%20WA%206109%2C%20Australia!5e0!3m2!1sen!2slk!4v1777483444194!5m2!1sen!2slk"
                                        style={{ border: 0, width: '100%', height: '100%' }}
                                        allowFullScreen=""
                                        loading="lazy"
                                    ></iframe>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
